import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { TERMS_URL, US_NO_INTEREST_OFFER } from '../../../USConstants';

import TermsText from '../../TermsText/TermsText';
import './TeslaAsideContent.less';

const LOCALE_PREFIX = 'US/components/AsideContent/AsideContent';

export class TeslaAsideContent extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
        imgElt: PropTypes.element,
        numMonths: PropTypes.number.isRequired
    };

    render() {
        const { imgElt, intl, numMonths } = this.props;
        const termsText = intl.formatHTMLMessage({ id: `${LOCALE_PREFIX}.terms-text-ni` }, { numMonths });
        const termsLinkText = intl.formatMessage({ id: `${LOCALE_PREFIX}.terms-details-link-ni` });

        const asideContentBody = (
            <div className="aside-content-body">
                <div className="aside-content-tagline">
                    <FormattedHTMLMessage
                        id={`${LOCALE_PREFIX}.tagline-ni`}
                        tagName="div"
                        values={{
                            numMonths: US_NO_INTEREST_OFFER.TERM
                        }}
                    />
                </div>
                <TermsText name={'ni-terms'}
                    termsUrl={TERMS_URL}
                    termsText={termsText}
                    termsLinkText={termsLinkText}
                />
            </div>
        );

        return (
            <div className="TeslaAsideContent">
                <div className="aside-content">
                    {imgElt && <div className="aside-content-icon">{imgElt}</div>}
                    {asideContentBody}
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    numMonths: _.get(state, 'serverData.financingDetails.term', US_NO_INTEREST_OFFER.TERM)
});

export default connect(mapStateToProps)(injectIntl(TeslaAsideContent));
